import { formatDecimal } from '@luminovo/commons';

//This is used instead of formatPercentage to maintain precision to three decimal places instead of 0
export function formatCalculationPercentage(percentage: string | number): string {
    const num = isNaN(Number(percentage)) ? 0 : Number(percentage);
    return formatDecimal(num) + `%`;
}
